import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@chakra-ui/react';
import { CardCarouselControlProps } from '@src/components/sco/CardCarousel/Controls/CardCarouselControlProps';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export const RightControl = props => {
  const $ = _c(15);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false]);
  const t0 = props.activeItemIndex === props.items.length - 1;
  const t1 = isMobile ? -1.5 : undefined;
  let t2;
  if ($[0] !== getBreakpointValue) {
    t2 = getBreakpointValue(["xs", "xs", "md", "md"]);
    $[0] = getBreakpointValue;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "none"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props) {
    t4 = () => props.nextItem();
    $[3] = props;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== getBreakpointValue) {
    t5 = getBreakpointValue([4, 4, 6, 6]);
    $[5] = getBreakpointValue;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <ChevronRightIcon boxSize={t5} color="white" />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t4 || $[13] !== t6) {
    t7 = <IconButton aria-label="Next Item" bgColor="BurntOrange" disabled={t0} left={t1} size={t2} _disabled={t3} onClick={t4}>{t6}</IconButton>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};